import styled from "styled-components";
import { TextField as MuiTextField } from "@mui/material";

import { InputTypes } from "../../store";

export const SubTextField = styled.span`
  font-size: 14px;
  padding-left: 3px;
  margin-bottom: 16px;
  margin-top: -8px;


    p {
        font-size: 14px;
    }
    ul, ol {
        list-style-type: disc !important; /* 혹은 decimal */
        list-style-position: inside !important; /* 리스트 아이템 안쪽에 표시 */
    }

    li {
        display: list-item !important; /* 명시적으로 리스트 아이템으로 설정 */
        margin-bottom: 8px;
    }

`;
